import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '../../lib/utils';

const iconButtonVariants = cva(
  [
    'inline-flex items-center justify-center rounded-[4px] shrink-0',
    'transition-colors duration-150',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
    'disabled:pointer-events-none disabled:opacity-50',
  ],
  {
    variants: {
      variant: {
        'on-dark': 'text-white hover:bg-white/10',
        'on-light': 'text-dawn-black hover:bg-grey-100',
      },
      size: {
        sm: 'w-[20px] h-[20px]',
        md: 'w-[24px] h-[24px]',
        lg: 'w-[32px] h-[32px]',
      },
    },
    defaultVariants: {
      variant: 'on-dark',
      size: 'md',
    },
  }
);

export interface IconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof iconButtonVariants> {}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, variant, size, type = 'button', ...props }, ref) => {
    return (
      <button
        ref={ref}
        type={type}
        className={cn(iconButtonVariants({ variant, size }), className)}
        {...props}
      />
    );
  }
);

IconButton.displayName = 'IconButton';
